import type { SVGProps } from 'react';

export const LocationFillViewfinderSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 19.7092 19.3594"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="19.3594" opacity="0" width="19.7092" x="0" y="0" />{' '}
        <path
          d="M0.953509 6.52753C1.58007 6.52753 1.91327 6.17655 1.91327 5.55624L1.91327 3.34999C1.91327 2.40116 2.40643 1.9328 3.31444 1.9328L5.5705 1.9328C6.20058 1.9328 6.54179 1.58983 6.54179 0.971282C6.54179 0.352732 6.20058 0.0195312 5.5705 0.0195312L3.20351 0.0195312C1.0957 0.0195312 0 1.09746 0 3.183L0 5.55624C0 6.17831 0.342966 6.52753 0.953509 6.52753ZM18.3881 6.52753C19.0146 6.52753 19.3478 6.17831 19.3478 5.55624L19.3478 3.183C19.3478 1.09746 18.2539 0.0195312 16.1443 0.0195312L13.7693 0.0195312C13.149 0.0195312 12.8061 0.352732 12.8061 0.971282C12.8061 1.58983 13.1508 1.9328 13.7693 1.9328L16.0254 1.9328C16.9254 1.9328 17.4346 2.40116 17.4346 3.34999L17.4346 5.55624C17.4346 6.17831 17.7775 6.52753 18.3881 6.52753ZM3.20351 19.3594L5.5705 19.3594C6.20058 19.3594 6.54179 19.0164 6.54179 18.4059C6.54179 17.7873 6.19706 17.4461 5.5705 17.4461L3.31444 17.4461C2.40643 17.4461 1.91327 16.9777 1.91327 16.0271L1.91327 13.8209C1.91327 13.1926 1.57206 12.8496 0.953509 12.8496C0.333201 12.8496 0 13.1926 0 13.8209L0 16.1879C0 18.2797 1.0957 19.3594 3.20351 19.3594ZM13.7693 19.3594L16.1443 19.3594C18.2539 19.3594 19.3478 18.2717 19.3478 16.1879L19.3478 13.8209C19.3478 13.1926 19.0066 12.8496 18.3881 12.8496C17.7695 12.8496 17.4346 13.1943 17.4346 13.8209L17.4346 16.0271C17.4346 16.9777 16.9254 17.4461 16.0254 17.4461L13.7693 17.4461C13.149 17.4461 12.8061 17.7873 12.8061 18.4059C12.8061 19.0164 13.149 19.3594 13.7693 19.3594Z"
          fill="currentColor"
        />{' '}
        <path
          d="M4.6871 10.4891L8.5873 10.4971C8.78613 10.4971 8.90859 10.6195 8.90859 10.8184L8.90859 14.6785C8.90859 15.567 9.89784 15.727 10.2348 14.9947L14.3738 6.12108C14.743 5.32519 14.0404 4.62441 13.2383 4.9998L4.38065 9.1709C3.63866 9.51933 3.81464 10.4891 4.6871 10.4891Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
